import React from "react";
import PropTypes from "prop-types";

import { Translation as T } from "@awe-web/shared/lib";
import {ScreenSectionHeading} from "../../../components/screen.js";
import { Col, Row } from "../../../components/grid.js";

const SEPA_HEADING = "ALG0000135";
const SEPA_TEXT_1 = "ALG0000136";
const SEPA_TEXT_2 = "ALG0000137";

const ON_ACCOUNT_HEADING = "ALG0000138";
const ON_ACCOUNT_TEXT_1 = "ALG0000139";
const ON_ACCOUNT_TEXT_2 = "ALG0000140";

const ACCOUNT_HOLDER_LABEL = "ALG0000099";
const IBAN_LABEL = "ALG0000100";
const BIC_LABEL = "ALG0000101";
const BANK_LABEL = "ALG0000141";

export default function PaymentDetails({paymentDetails}) {

  const {
    PAYMENT_HEADING,
    PAYMENT_TEXT_1,
    PAYMENT_TEXT_2
  } = (() => {
    if (paymentDetails.type === "SEPA") {
      return {
        PAYMENT_HEADING: SEPA_HEADING,
        PAYMENT_TEXT_1: SEPA_TEXT_1,
        PAYMENT_TEXT_2: SEPA_TEXT_2
      };
    }
    else {
      return {
        PAYMENT_HEADING: ON_ACCOUNT_HEADING,
        PAYMENT_TEXT_1: ON_ACCOUNT_TEXT_1,
        PAYMENT_TEXT_2: ON_ACCOUNT_TEXT_2
      };
    }
  })();

  return (
    <>
      <Row>
        <Col desktop={{ cols: 8, offset: 2 }}>
          <ScreenSectionHeading light><T code={PAYMENT_HEADING} /></ScreenSectionHeading>
        </Col>
      </Row>

      <Row>
        <Col
          className="b2b-payment__method-text"
          tablet={{ cols: 5 }}
          desktop={{ cols: 4, offset: 2 }}
        >
          <p><T code={PAYMENT_TEXT_1} /></p>
          <p><T code={PAYMENT_TEXT_2} /></p>
        </Col>
        <Col tablet={{ cols: 3 }} desktop={{ cols: 4 }}>
          <div className="b2b-payment__labeled-value">
            <div className="b2b-payment__labeled-value__label">
              <T code={ACCOUNT_HOLDER_LABEL} />
            </div>
            <div>{paymentDetails.accountHolder}</div>
          </div>

          <div className="b2b-payment__labeled-value">
            <div className="b2b-payment__labeled-value__label">
              <T code={IBAN_LABEL} />
            </div>
            <div>{paymentDetails.iban}</div>
          </div>

          <div className="b2b-payment__labeled-value">
            <div className="b2b-payment__labeled-value__label">
              <T code={BIC_LABEL} />
            </div>
            <div>{paymentDetails.bic}</div>
          </div>

          <div className="b2b-payment__labeled-value">
            <div className="b2b-payment__labeled-value__label">
              <T code={BANK_LABEL} />
            </div>
            <div>{paymentDetails.bank}</div>
          </div>
        </Col>
      </Row>
    </>
  );
}

PaymentDetails.propTypes = {
  paymentDetails: PropTypes.shape({
    type: PropTypes.oneOf(["SEPA", "ON_ACCOUNT"]),
    accountHolder: PropTypes.string,
    iban: PropTypes.string,
    bic: PropTypes.string,
    bank: PropTypes.string
  })
};
